'use strict';

const FancyDropDown = require('../../fancy_drop_down/frontend/fancy_drop_down');

module.exports = (function() {
  class OffersMapFilters {
    static initClass() {
      this.prototype.onChangeCallbacks = [];
      this.prototype.templates = {
        main: require('../main.html.mustache'),
      };
    }

    constructor({ el, config, history }) {
      this.historyHandler = this.historyHandler.bind(this);
      this.triggerChange = this.triggerChange.bind(this);
      this.config = config;
      this.history = history;
      this.$el = $(el);
      this.render();
      this.$filters = this.$el.find('.offers-map-filters');
      this.$deals = this.$el.find('.filter-by-deals input');
      this.$onlineOrdering = this.$el.find('.filter-by-online-ordering input');
      this.$openNow = this.$el.find('.filter-by-open-now input');
      this.history.onPop(this.historyHandler);
    }

    render() {
      const data = {
        config: this.config,
      };

      data.translate = data.t = () => str => I18n.t(str);

      this.$el.html(this.templates.main.render(data));
      const sortByOptions = [
        {
          text: I18n.t('js.modules.offers_map_filters.sort_by.relevance'),
          value: 'relevance',
          isSelected: true,
        },
        {
          text: I18n.t('js.modules.offers_map_filters.sort_by.best_rated'),
          value: 'rating',
        },
        {
          text: I18n.t('js.modules.offers_map_filters.sort_by.distance'),
          value: 'distance',
        },
      ];
      this.sortByDropDown = new FancyDropDown({
        el: this.$el.find('.sort-by-drop-down'),
        options: sortByOptions,
      });
      this.sortByDropDown.onChange(this.triggerChange);
      this.$el.find('input').change(this.triggerChange);
      this.$el.find('.icon-x').click(() => this.hideMobileModal());
      return this.$el;
    }

    historyHandler({ action }) {
      if (action === 'filters-show-modal') {
        return this.showMobileModal(false);
      } else if (
        action === 'filters-hide-modal' ||
        this.$filters.hasClass('show-phone-modal')
      ) {
        return this.hideMobileModal(false);
      }
      return null;
    }

    showMobileModal(saveInHistory = true) {
      this.$filters.addClass('show-phone-modal');

      if (saveInHistory) {
        return this.history.add({
          action: 'filters-show-modal',
        });
      }
      return null;
    }

    hideMobileModal(saveInHistory = true) {
      this.$filters.removeClass('show-phone-modal');

      if (saveInHistory) {
        return this.history.add({
          action: 'filters-hide-modal',
        });
      }
      return null;
    }

    triggerChange() {
      return this.onChangeCallbacks.map(cb => {
        cb();
      });
    }

    onChange(cb) {
      this.onChangeCallbacks.push(cb);
    }

    values() {
      const deals = this.$deals.is(':checked');
      const onlineOrdering = this.$onlineOrdering.is(':checked');
      const openNow = this.$openNow.is(':checked');
      let count = 0;

      for (const filter of [deals, onlineOrdering, openNow]) {
        if (filter === true) {
          count += 1;
        }
      }

      return {
        deals,
        onlineOrdering,
        openNow,
        count,
        sortBy: this.sortByDropDown.value(),
      };
    }

    clear() {
      const $checked = this.$el.find('input:checked');
      const shouldTriggerChange = $checked.length > 0;
      $checked.attr('checked', false);

      if (shouldTriggerChange) {
        return this.triggerChange();
      }
      return null;
    }
  }
  OffersMapFilters.initClass();
  return OffersMapFilters;
})();
